<template>
    <div class="search">
        <el-input :placeholder="plac?plac:'搜索职位、园所'" v-model="searchVal" class="input-with-select" @keyup.enter.native="goPost">
            <el-button ref="btn" slot="append" class="searchBtn" @click="goPost">搜索</el-button>
        </el-input>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                searchVal: ''
            }
        },
        props: {
            plac: String,
            go: Boolean
        },
        methods: {
            // 去职位列表
            goPost() {
                if(!this.go) {
                    this.$emit('getList', 0, this.searchVal)
                } else {
                    this.$router.push({ 
                        path: '/job/post',
                        query: {
                            keywords: this.searchVal
                        }
                    })
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .input-with-select {
        box-shadow: 0 0 6px 0 rgba(0,0,0,.13);
        .searchBtn {
            width: 140px;
            background: #FF5B12 !important;
            color: white !important;
            border-radius: 0;
            height: 40px;
        }
    }
</style>

<style lang="scss">
    .input-with-select {
        input {
            border: none !important;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/search/index.vue